import { useEffect, useState } from 'react';
import type { ReferentielRegion } from './perimetreCoverage';

/**
 * Charge le referentiel regions + departements (GET /perimetre/referentiel).
 * Partage par le selecteur (edition) et l'affichage carte (lecture seule).
 */
export function usePerimetreReferentiel() {
  const [referentiel, setReferentiel] = useState<ReferentielRegion[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancel = false;
    const load = async () => {
      try {
        const token = localStorage.getItem('token');
        const apiUrl = process.env.REACT_APP_API_URL || '';
        const res = await fetch(`${apiUrl}/perimetre/referentiel`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error('Referentiel indisponible');
        const json = await res.json();
        if (!cancel) setReferentiel(json.data || []);
      } catch (e) {
        if (!cancel) setError('Impossible de charger la liste des regions et departements.');
      } finally {
        if (!cancel) setLoading(false);
      }
    };
    load();
    return () => { cancel = true; };
  }, []);

  return { referentiel, loading, error };
}
